import GraphQLClientService from '../../services/GraphQLClientService';
import { LanduseEntity } from '../../ResponseObjects/Schemas/LandUseEntity';
import { Stage,GeometryType } from '../../constants/progress';
import { useProgressStore } from '../../store/progressStore';

export default async function fetchLanduseData(minX, minY, maxX, maxY) {
  const updateProgress = useProgressStore.getState().updateProgress;
  const geometryType = GeometryType.LANDUSE;

  if (minX === undefined || minY === undefined || maxX === undefined || maxY === undefined) {
    updateProgress(geometryType,{
      stage: Stage.ERROR,
      message: "Missing bounding box",
      error: "All boundary parameters (minX, minY, maxX, maxY) are required"
    });
    
    throw new Error('All boundary parameters (minX, minY, maxX, maxY) are required');
  }
  updateProgress(geometryType,
    {
      stage: Stage.QUERY,
      message:'Fetching data from server',
      progress: 25,
      error: null
    }
  )

  const query = `query DevelopmentPlanByBounds 
  {
    landuseByBounds(
      minLat: ${maxY}
      minLon:${maxX}
      maxLat: ${minY}
      maxLon: ${minX}
      outputCRS: EPSG25832
      revitProtocol: true
    
    ) {
        landuse {
            geometry
            id
            type
            landuseType
            stateKey
            isClipped
        }
    }
  }`;

  const client = new GraphQLClientService();

  try {
    const response = await client.executeQueryAsync(query);
    
    if (response.data.landuseByBounds.landuse.length > 0) {
      updateProgress(geometryType,{
        stage: Stage.QUERYSTAGE,
        message:"Fetched data from the server",
        progress:50,// need to change the progress
        fetched: response.data.landuseByBounds.length
      })
      const bPlanEntities = LanduseEntity.fromResponse(response);
      updateProgress(geometryType,{
        stage: Stage.PROCESSINGSTAGE,
        message:"Processed fetched data from the server",
        progress:50,// need to change the progress
        processed: bPlanEntities.length
      })
      return bPlanEntities;
    } else {
      updateProgress(geometryType,{
        stage: Stage.NULL,
        message:"No data returned or an error occurred.",
        progress:50,// need to change the progress
        fetched: response.data.landuseByBounds.length
      })
      console.log('No data returned or an error occurred.');
      return null;
    }
  } catch (error) {
      updateProgress(geometryType,{
        stage: Stage.ERROR,
        message:"Error during GraphQL request",
        progress:50,// need to change the progress
        
      })
    console.error('Error during GraphQL request:', error);
    throw error; 
  }
}